
export enum LeadSystemStage {

    /* default after creating */
    New = 'New',
    InProgress = 'In Progress',

    /* Qualified: indicates the possibility of converting to a customer */
    Qualified = 'Qualified',

    /* Indicates the lost of a lead */
    Disqualified = 'Disqualified'

}

export const LeadSystemStages = Object.values(LeadSystemStage);



// export interface LeadStage extends Entity {
//     system?: boolean; // This is determines if item can be deleted
//     systemStage: OpportunitySystemStage;
//     systemName: OpportunityStageSystemName | string;
//     description: string;
//     probability: number;
// }